import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { NewAprovadorDTO } from '../models/newAprovadorDTO.model';
import { AprovadorDTO } from '../models/aprovadorDTO.model';

@Injectable({
  providedIn: 'root'
})
export class AprovadorService {
  configHeader: { headers: { Authorization: any; }; };

  constructor(
    private http: HttpClient
    ) { }
  
  public insertAprovador(aprovador: NewAprovadorDTO, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/aprovadores`, aprovador, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, (err) => {
            reject(err);
          }
        )
    })
  }  

  public bulkInsertAprovadores(aprovadores: NewAprovadorDTO[], token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/aprovadores/bulk`, aprovadores, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, (err) => {
            reject(err.error.message);
          }
        )
    })
  }

  public updateAprovador(aprovador: NewAprovadorDTO, idAprovador: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token }},
      this.http.put(`${environment.url_api}/aprovadores/${idAprovador}`, aprovador, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  
  public excluirAprovador(idAprovador: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.delete(`${environment.url_api}/aprovadores/${idAprovador}`, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public findAllAprovadoresByCandidaturaId(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get<AprovadorDTO[]>(`${environment.url_api}/aprovadores/by-candidatura?candidaturaId=${id}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }
  
  public enviarEmailsLoginAprovador(id: number, Aprovadores: AprovadorDTO[], token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      
        this.http.post(`${environment.url_api}/candidaturas/${id}/enviaEmails`, Aprovadores ,this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  public findAllAprovadoresByCandidaturaIdPage(candidaturaId: number,linesPerPage:number,page: number, login: string, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get<AprovadorDTO[]>(`${environment.url_api}/aprovadores/page?candidaturaId=${candidaturaId}&linesPerPage=${linesPerPage}&page=${page}&login=${login}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  public recuperacaoSenhaAprovadorEmail(param: String) {
    return new Promise((resolve, reject)=> {
      this.http.post(`${environment.url_api}/aprovadores/emailRedefinirSenhaAprovador`, param).subscribe(
        payload=>{
          resolve(payload)
        }, err =>{
          reject(err.error.message)
        }
      )
    });
  }
  
}
